import React from 'react';
import ExpandableContainer from '../ExpandableContainer';
import * as Row from '../../../layout/Row';

export default class SummaryControllerSection extends React.Component {
    fallback = '-'

    render() {

        if (this.props.model.unitType.isCustomLogic.value)
            return (<React.Fragment></React.Fragment>)

        const renderField = (field, label = null) => {
            if (typeof field === 'undefined' || field.value === null || !field.visible) {
                return <React.Fragment></React.Fragment>;
            }

            return (
                <tr>
                    <td>{label || field.label}</td>
                    <td>{this.getFieldValue(field)}</td>
                </tr>
            )
        }

        var content =
            <React.Fragment>
                <tbody>
                {renderField(this.props.model.controller.controlCenter, __('Controller'))}
                {renderField(this.props.model.controller.software)}
                {renderField(this.props.model.controller.upgradedControllerDisplay)}
                {renderField(this.props.model.controller.addOnOption1)}
                {renderField(this.props.model.controller.addOnOption2)}
                {renderField(this.props.model.controller.addOnOption3)}
                {renderField(this.props.model.controller.addOnOption4)}
                {renderField(this.props.model.controller.router)}

                {this.props.model.controller.referenceTemperatureSensor.value && (
                    <tr>
                        <td>{this.props.model.controller.referenceTemperatureSensor.label}</td>
                        <td>{this.getFieldValue(this.props.model.controller.referenceTemperatureSensor)} ({this.props.model.controller.refSensCount.value} pcs)</td>
                    </tr>
                )}

                </tbody>
            </React.Fragment>

        return (
            <ExpandableContainer label={__('Controller')}>
                <div className="summary-controller-section">
                    <Row.Container hasOuterGutter={false}>
                        <div className="column-5 column-xs-12">
                            {this.renderTableContainer('General', content)}
                        </div>

                        <div className="column-7 column-xs-12">
                            {this.renderTemperatureSensors()}
                        </div>
                    </Row.Container>

                    <div style={{width: '100%', height: '2.5rem'}}></div>

                    <Row.Container hasOuterGutter={false}>
                        <div className="column-5 column-xs-12">
                            {this.renderOther()}
                        </div>

                        <div className="column-7 column-xs-12">
                            {this.renderThermometerSensors()}
                        </div>
                    </Row.Container>

                    <div style={{width: '100%', height: '2.5rem'}}></div>

                    <Row.Container hasOuterGutter={false}>
                        {this.props.model.unitType.isMaxiCompactLogic.value &&
                            <Row.Column5>{this.renderOtherCombibox()}</Row.Column5>}
                    </Row.Container>
                </div>
            </ExpandableContainer>
        )
    }

    renderTableContainer(title, content) {
        return (
            <React.Fragment>
                <div className="configuration-editor-summary-ut-section">
                    <div>{__(title)}</div>
                    <div className="configuration-editor-summary-table-wrapper">
                        <table className="configuration-editor-summary-table-multi">
                            {content}
                        </table>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    renderOtherCombibox() {
        var content =
            <React.Fragment>
                <tbody>
                <tr>
                    <td>{__('Outside air temp sensor')}</td>
                    {this.renderField(this.props.model.controller.outdoorTemperatureSensor)}
                </tr>
                </tbody>
            </React.Fragment>

        return (
            this.renderTableContainer('Other', content)
        )
    }

    renderOther() {
        var circuits = [
            this.props.model.heating1,
            this.props.model.heating2,
            this.props.model.heating3,
            this.props.model.dhw,
        ].filter(x => x !== undefined)

        var content =
            <React.Fragment>
                <thead>
                <tr>
                    <th></th>
                    {'heating1' in this.props.model && <th>{this.props.model.heating1.name.value}</th>}
                    {'heating2' in this.props.model && <th>{this.props.model.heating2.name.value}</th>}
                    {'heating3' in this.props.model && <th>{this.props.model.heating3.name.value}</th>}
                    {'dhw' in this.props.model && <th>{this.props.model.dhw.name.value}</th>}
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{__('Return pressure sensor')}</td>
                    {circuits.map((c, i) => this.tryRenderField(c, i, 'returnPressureSensor'))}
                </tr>
                <tr>
                    <td>{__('Manometer')}</td>
                    {circuits.map((c, i) => this.tryRenderField(c, i, 'manometer'))}
                </tr>
                </tbody>
            </React.Fragment>

        return (
            this.renderTableContainer('Other', content)
        )
    }

    renderTemperatureSensors() {
        const getHeating = (heating, getPrimaryHeating) => heating === undefined ? undefined : {
            ...heating,
            temperatureSensorPrimaryReturn: this.props.model.primarySideEquipment ? (getPrimaryHeating() || {}).temperatureSensorPrimaryReturn : undefined
        }

        const getDHW = () => this.props.model.dhw === undefined ? undefined : {
            ...this.props.model.dhw,
            dhwFlowTemperatureSensor: this.props.model.controller.dhwFlowTemperatureSensor,
            dhwCircularTemperatureSensor: this.props.model.controller.dhwCircularTemperatureSensor
        }

        const getPrimary = () => {
            if (!this.props.model.primarySideEquipment) {
                return undefined;
            }

            return {
                tedhFlow: this.props.model.primarySideEquipment.tedhFlow,
                tedhRet: this.props.model.primarySideEquipment.tedhRet
            }
        }

        const circuits = [
            {
                ...getHeating(this.props.model.heating1, () => this.props.model.primarySideEquipment.heating1),
                outdoorTemperatureSensor: this.props.model.controller.outdoorTemperatureSensor
            },
            getHeating(this.props.model.heating2, () => this.props.model.primarySideEquipment.heating2),
            getHeating(this.props.model.heating3, () => this.props.model.primarySideEquipment.heating3),
            getDHW(),
            getPrimary()
        ].filter(x => x !== undefined);

        const flowTemperatureSensor = 'flowTemperatureSensor'
        const dhwCircularTemperatureSensor = 'dhwCircularTemperatureSensor'

        if (circuits.some(x => (x[flowTemperatureSensor] !== undefined && x[flowTemperatureSensor].visible === false) || (x[dhwCircularTemperatureSensor] != undefined && x[dhwCircularTemperatureSensor].visible === false)))
            return <React.Fragment/>

        var content =
            <React.Fragment>
                <thead>
                <tr>
                    <th></th>
                    {'heating1' in this.props.model && <th>{this.props.model.heating1.name.value}</th>}
                    {'heating2' in this.props.model && <th>{this.props.model.heating2.name.value}</th>}
                    {'heating3' in this.props.model && <th>{this.props.model.heating3.name.value}</th>}
                    {'dhw' in this.props.model && <th>{this.props.model.dhw.name.value}</th>}
                    {<th>{__('Primary')}</th>}
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{__('Flow')}</td>
                    {circuits.map((c, i) => this.tryRenderField(c, i, 'flowTemperatureSensor'))}
                </tr>
                <tr>
                    <td>{__('Return')}</td>
                    {circuits.map((c, i) => this.tryRenderField(c, i, 'returnTemperatureSensor'))}
                </tr>
                <tr>
                    <td>{__('Primary return, heating')}</td>
                    {circuits.map((c, i) => this.tryRenderField(c, i, 'temperatureSensorPrimaryReturn'))}
                </tr>
                {(this.props.model.primarySideEquipment && this.props.model.primarySideEquipment.dhw) &&
                    <React.Fragment>
                        <tr>
                            <td>{__('Hot water')}</td>
                            {circuits.map((c, i) => this.tryRenderField(c, i, 'dhwFlowTemperatureSensor'))}
                        </tr>
                        <tr>
                            <td>{__('Hot water circulation')}</td>
                            {circuits.map((c, i) => this.tryRenderField(c, i, 'dhwCircularTemperatureSensor'))}
                        </tr>
                    </React.Fragment>
                }
                <tr>
                    <td>{__('Primary flow')}</td>
                    {circuits.map((c, i) => this.tryRenderField(c, i, 'tedhFlow'))}
                </tr>
                <tr>
                    <td>{__('Primary return')}</td>
                    {circuits.map((c, i) => this.tryRenderField(c, i, 'tedhRet'))}
                </tr>
                <tr>
                    <td>{__('Outdoor temperature sensor')}</td>
                    {circuits.map((c, i) => this.tryRenderField(c, i, 'outdoorTemperatureSensor'))}
                </tr>
                <tr>
                    <td>{__('Reference temperature sensors')}</td>
                    <td style={{
                        textAlign: 'center'
                    }} colSpan={circuits.length}>{this.getReferenceTemperatureSensorForTemperatureSensors()}</td>
                </tr>
                </tbody>
            </React.Fragment>

        return (
            this.renderTableContainer('Reference sensors', content)
        )
    }

    getReferenceTemperatureSensorForTemperatureSensors = () => {
        if (this.props.model.controller.referenceTemperatureSensor.value) {
            return `${this.getFieldValue(this.props.model.controller.referenceTemperatureSensor)} (${this.props.model.controller.refSensCount.value})`
        }

        return '-';
    }

    renderThermometerSensors() {
        const getHeating = (heating, getPrimaryHeating) => heating === undefined ? undefined : {
            ...heating,
            thermometerPrimaryHeatingReturn: this.props.model.primarySideEquipment ? (getPrimaryHeating() || {}).thermometerPrimaryHeatingReturn : undefined
        }

        const getDHW = () => this.props.model.dhw === undefined ? undefined : {
            ...this.props.model.dhw,
            dhwFlowThermometer: this.props.model.controller.dhwFlowThermometer,
            coldWaterThermometer: this.props.model.controller.coldWaterThermometer,
            dhwCircularThermometer: this.props.model.controller.dhwCircularThermometer
        }

        const getPrimary = () => {
            if (!this.props.model.primarySideEquipment) {
                return undefined;
            }

            return {
                thermometerPrimarySupply: this.props.model.primarySideEquipment.thermometerPrimarySupply,
                thermometerPrimaryReturn: this.props.model.primarySideEquipment.thermometerPrimaryReturn
            }
        }

        const circuits = [
            getHeating(this.props.model.heating1, () => this.props.model.primarySideEquipment.heating1),
            getHeating(this.props.model.heating2, () => this.props.model.primarySideEquipment.heating2),
            getHeating(this.props.model.heating3, () => this.props.model.primarySideEquipment.heating3),
            getDHW(),
            getPrimary()
        ].filter(x => x !== undefined);

        var content =
            <React.Fragment>
                <thead>
                <tr>
                    <th></th>
                    {'heating1' in this.props.model && <th>{this.props.model.heating1.name.value}</th>}
                    {'heating2' in this.props.model && <th>{this.props.model.heating2.name.value}</th>}
                    {'heating3' in this.props.model && <th>{this.props.model.heating3.name.value}</th>}
                    {'dhw' in this.props.model && <th>{this.props.model.dhw.name.value}</th>}
                    {<th>{__('Primary')}</th>}
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{__('Flow')}</td>
                    {circuits.map((c, i) => this.tryRenderField(c, i, 'flowThermometer'))}
                </tr>
                <tr>
                    <td>{__('Return')}</td>
                    {circuits.map((c, i) => this.tryRenderField(c, i, 'returnThermometer'))}
                </tr>
                <tr>
                    <td>{__('Primary return, heating')}</td>
                    {circuits.map((c, i) => this.tryRenderField(c, i, 'thermometerPrimaryHeatingReturn'))}
                </tr>
                {(this.props.model.primarySideEquipment && this.props.model.primarySideEquipment.dhw) &&
                    <React.Fragment>
                        <tr>
                            <td>{__('Hot water')}</td>
                            {circuits.map((c, i) => this.tryRenderField(c, i, 'dhwFlowThermometer'))}
                        </tr>
                        <tr>
                            <td>{__('Cold water')}</td>
                            {circuits.map((c, i) => this.tryRenderField(c, i, 'coldWaterThermometer'))}
                        </tr>
                        <tr>
                            <td>{__('Hot water circulation')}</td>
                            {circuits.map((c, i) => this.tryRenderField(c, i, 'dhwCircularThermometer'))}
                        </tr>
                    </React.Fragment>
                }
                <tr>
                    <td>{__('Primary flow')}</td>
                    {circuits.map((c, i) => this.tryRenderField(c, i, 'thermometerPrimarySupply'))}
                </tr>
                <tr>
                    <td>{__('Primary return')}</td>
                    {circuits.map((c, i) => this.tryRenderField(c, i, 'thermometerPrimaryReturn'))}
                </tr>
                </tbody>
            </React.Fragment>

        return (
            this.renderTableContainer('Thermometers', content)
        )
    }

    renderThermometers() {
        var content =
            <React.Fragment>
                <thead>
                <tr>
                    <th></th>
                    {'heating1' in this.props.model && <th>{this.props.model.heating1.name.value}</th>}
                    {'heating2' in this.props.model && <th>{this.props.model.heating2.name.value}</th>}
                    {'heating3' in this.props.model && <th>{this.props.model.heating3.name.value}</th>}
                </tr>
                </thead>

                <tbody>
                <tr>
                    <td>{__('Flow thermometer')}</td>
                    {'heating1' in this.props.model && this.renderHeatingField(1, 'flowThermometer')}
                    {'heating2' in this.props.model && this.renderHeatingField(2, 'flowThermometer')}
                    {'heating3' in this.props.model && this.renderHeatingField(3, 'flowThermometer')}
                </tr>
                <tr>
                    <td>{__('Return thermometer')}</td>
                    {'heating1' in this.props.model && this.renderHeatingField(1, 'returnThermometer')}
                    {'heating2' in this.props.model && this.renderHeatingField(2, 'returnThermometer')}
                    {'heating3' in this.props.model && this.renderHeatingField(3, 'returnThermometer')}
                </tr>
                </tbody>
            </React.Fragment>

        return (
            this.renderTableContainer(content)
        )
    }

    tryRenderField(model, i, field, fallback = this.fallback) {
        if (model == undefined || !(field in model))
            return <td key={i}>{fallback}</td>

        return this.renderField(model[field], i)
    }

    renderField(field, key = null, fallback = this.fallback) {
        var attrs = key == null ? {} : {key}
        return <td {...attrs}>{this.getFieldValue(field) || fallback}</td>
    }

    renderHeatingField(heatingIndex, fieldName, fallback = '-') {
        let heatingModel = this.props.model['heating' + heatingIndex]
        if (typeof heatingModel === 'undefined') {
            return <td>-</td>;
        }

        let field = heatingModel[fieldName]
        if (!field.visible) {
            return <td>-</td>;
        }
        if (field.items && field.value) {
            return <td>{(field.items.find(x => x.value === field.value) || {}).text}</td>
        }

        return <td>{this.getFieldValue(field) || fallback}</td>;
    }

    getFieldValue(field) {
        if (!field)
            return '-';
        if (!field.visible)
            return '-'
        if (field.items) {
            let val = field.items.find(x => x.value === field.value)
            if (typeof val === 'object') {
                return val.text
            }
        }

        return field.value
    }
}